var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationCube3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.378,
    height: 91.304,
    viewBox: "0 0 55.378 91.304",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182523",
    "data-name": "\\uADF8\\uB8F9 182523",
    transform: "translate(-15.372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182028",
    "data-name": "\\uADF8\\uB8F9 182028",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181900",
    "data-name": "\\uADF8\\uB8F9 181900",
    transform: "translate(25.767 59.28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181893",
    "data-name": "\\uADF8\\uB8F9 181893",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181891",
    "data-name": "\\uADF8\\uB8F9 181891",
    transform: "translate(0.239 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130500",
    "data-name": "\\uD328\\uC2A4 130500",
    d: "M866.3,454.655l14.021,7.812V446L866.3,438.19Z",
    transform: "translate(-866.299 -438.19)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181892",
    "data-name": "\\uADF8\\uB8F9 181892"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130501",
    "data-name": "\\uD328\\uC2A4 130501",
    d: "M879.958,462.344a.23.23,0,0,1-.116-.031L865.821,454.5a.235.235,0,0,1-.123-.207V437.829a.239.239,0,0,1,.355-.207l14.021,7.812a.237.237,0,0,1,.122.208v16.465a.236.236,0,0,1-.117.2A.233.233,0,0,1,879.958,462.344Zm-13.783-8.19,13.545,7.546V445.782l-13.545-7.546Z",
    transform: "translate(-865.698 -437.591)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181896",
    "data-name": "\\uADF8\\uB8F9 181896"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181894",
    "data-name": "\\uADF8\\uB8F9 181894",
    transform: "translate(0.239 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130502",
    "data-name": "\\uD328\\uC2A4 130502",
    d: "M866.3,427.353l14.1,7.827,12.8-7.174-14.1-7.826Z",
    transform: "translate(-866.299 -420.18)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181895",
    "data-name": "\\uADF8\\uB8F9 181895"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130503",
    "data-name": "\\uD328\\uC2A4 130503",
    d: "M880.04,435.057a.241.241,0,0,1-.116-.03l-14.1-7.826a.238.238,0,0,1,0-.416l12.8-7.173a.24.24,0,0,1,.233,0l14.1,7.826a.239.239,0,0,1,0,.417l-12.8,7.173A.236.236,0,0,1,880.04,435.057Zm-13.614-8.066,13.614,7.555,12.31-6.9-13.613-7.554Z",
    transform: "translate(-865.698 -419.58)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181899",
    "data-name": "\\uADF8\\uB8F9 181899",
    transform: "translate(14.282 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181897",
    "data-name": "\\uADF8\\uB8F9 181897",
    transform: "translate(0.239 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130504",
    "data-name": "\\uD328\\uC2A4 130504",
    d: "M914.872,456.867,902.251,463.6v-16.63l12.621-7.091Z",
    transform: "translate(-902.251 -439.88)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181898",
    "data-name": "\\uADF8\\uB8F9 181898"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130505",
    "data-name": "\\uD328\\uC2A4 130505",
    d: "M901.889,463.477a.244.244,0,0,1-.123-.033.24.24,0,0,1-.116-.2v-16.63a.239.239,0,0,1,.122-.208l12.621-7.091a.238.238,0,0,1,.356.207v16.988a.24.24,0,0,1-.126.21L902,463.449A.237.237,0,0,1,901.889,463.477Zm.238-16.729v16.094l12.144-6.48V439.926Zm12.383,9.757h0Z",
    transform: "translate(-901.65 -439.28)",
    fill: "#111"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181920",
    "data-name": "\\uADF8\\uB8F9 181920",
    transform: "translate(15.372 45.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181913",
    "data-name": "\\uADF8\\uB8F9 181913",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181911",
    "data-name": "\\uADF8\\uB8F9 181911",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130512",
    "data-name": "\\uD328\\uC2A4 130512",
    d: "M840.132,419.53l14.021,7.812V410.877l-14.021-7.812Z",
    transform: "translate(-840.132 -403.065)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181912",
    "data-name": "\\uADF8\\uB8F9 181912"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130513",
    "data-name": "\\uD328\\uC2A4 130513",
    d: "M853.792,427.218a.232.232,0,0,1-.116-.031l-14.021-7.812a.237.237,0,0,1-.122-.207V402.7a.239.239,0,0,1,.354-.209l14.021,7.812a.239.239,0,0,1,.122.209V426.98a.24.24,0,0,1-.238.238Zm-13.783-8.191,13.545,7.546V410.655l-13.545-7.546Z",
    transform: "translate(-839.532 -402.465)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181916",
    "data-name": "\\uADF8\\uB8F9 181916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181914",
    "data-name": "\\uADF8\\uB8F9 181914",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130514",
    "data-name": "\\uD328\\uC2A4 130514",
    d: "M840.132,392.228l14.1,7.826,12.8-7.174-14.1-7.826Z",
    transform: "translate(-840.132 -385.055)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181915",
    "data-name": "\\uADF8\\uB8F9 181915"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130515",
    "data-name": "\\uD328\\uC2A4 130515",
    d: "M853.874,399.931a.236.236,0,0,1-.116-.03l-14.1-7.826a.24.24,0,0,1-.122-.208.236.236,0,0,1,.122-.209l12.8-7.174a.237.237,0,0,1,.232,0l14.1,7.826a.239.239,0,0,1,0,.416l-12.8,7.174A.24.24,0,0,1,853.874,399.931Zm-13.614-8.065,13.614,7.554,12.311-6.9-13.614-7.554Z",
    transform: "translate(-839.532 -384.454)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181919",
    "data-name": "\\uADF8\\uB8F9 181919",
    transform: "translate(14.282 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181917",
    "data-name": "\\uADF8\\uB8F9 181917",
    transform: "translate(0.239 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130516",
    "data-name": "\\uD328\\uC2A4 130516",
    d: "M888.7,421.742l-12.621,6.734v-16.63l12.621-7.091Z",
    transform: "translate(-876.084 -404.755)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181918",
    "data-name": "\\uADF8\\uB8F9 181918"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130517",
    "data-name": "\\uD328\\uC2A4 130517",
    d: "M875.722,428.353a.236.236,0,0,1-.123-.034.239.239,0,0,1-.116-.2v-16.63a.24.24,0,0,1,.122-.208l12.621-7.091a.238.238,0,0,1,.354.208v16.987a.238.238,0,0,1-.126.21l-12.621,6.735A.238.238,0,0,1,875.722,428.353Zm.238-16.729v16.093l12.144-6.479V404.8Zm12.383,9.756h0Z",
    transform: "translate(-875.483 -404.155)",
    fill: "#111"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181940",
    "data-name": "\\uADF8\\uB8F9 181940",
    transform: "translate(36.567 33.617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181933",
    "data-name": "\\uADF8\\uB8F9 181933",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181931",
    "data-name": "\\uADF8\\uB8F9 181931",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130524",
    "data-name": "\\uD328\\uC2A4 130524",
    d: "M893.484,390.055l14.021,7.812V381.4l-14.021-7.812Z",
    transform: "translate(-893.484 -373.591)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181932",
    "data-name": "\\uADF8\\uB8F9 181932"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130525",
    "data-name": "\\uD328\\uC2A4 130525",
    d: "M907.143,397.744a.241.241,0,0,1-.116-.03L893.007,389.9a.24.24,0,0,1-.123-.209V373.229a.239.239,0,0,1,.354-.209l14.021,7.812a.238.238,0,0,1,.122.208v16.464a.239.239,0,0,1-.117.206A.248.248,0,0,1,907.143,397.744Zm-13.782-8.19,13.545,7.547V381.181l-13.545-7.546Z",
    transform: "translate(-892.884 -372.991)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181936",
    "data-name": "\\uADF8\\uB8F9 181936"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181934",
    "data-name": "\\uADF8\\uB8F9 181934",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130526",
    "data-name": "\\uD328\\uC2A4 130526",
    d: "M893.484,362.754l14.1,7.826,12.8-7.174-14.1-7.826Z",
    transform: "translate(-893.484 -355.581)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181935",
    "data-name": "\\uADF8\\uB8F9 181935"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130527",
    "data-name": "\\uD328\\uC2A4 130527",
    d: "M907.225,370.457a.237.237,0,0,1-.116-.03l-14.1-7.826a.238.238,0,0,1,0-.416l12.8-7.173a.238.238,0,0,1,.232,0l14.1,7.826a.238.238,0,0,1,0,.416l-12.8,7.174A.239.239,0,0,1,907.225,370.457Zm-13.613-8.065,13.613,7.554,12.311-6.9-13.614-7.554Z",
    transform: "translate(-892.884 -354.981)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181939",
    "data-name": "\\uADF8\\uB8F9 181939",
    transform: "translate(14.282 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181937",
    "data-name": "\\uADF8\\uB8F9 181937",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130528",
    "data-name": "\\uD328\\uC2A4 130528",
    d: "M942.057,392.268,929.436,399v-16.63l12.621-7.092Z",
    transform: "translate(-929.436 -375.281)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181938",
    "data-name": "\\uADF8\\uB8F9 181938"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130529",
    "data-name": "\\uD328\\uC2A4 130529",
    d: "M929.074,398.879a.243.243,0,0,1-.122-.033.24.24,0,0,1-.116-.2V382.01a.239.239,0,0,1,.122-.208l12.621-7.092a.239.239,0,0,1,.356.208v16.987a.237.237,0,0,1-.126.21l-12.621,6.734A.244.244,0,0,1,929.074,398.879Zm.238-16.729v16.094l12.144-6.48V375.326Zm12.383,9.757h0Z",
    transform: "translate(-928.836 -374.68)",
    fill: "#111"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181950",
    "data-name": "\\uADF8\\uB8F9 181950",
    transform: "translate(21.433 42.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181943",
    "data-name": "\\uADF8\\uB8F9 181943",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181941",
    "data-name": "\\uADF8\\uB8F9 181941",
    transform: "translate(0.239 0.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130530",
    "data-name": "\\uD328\\uC2A4 130530",
    d: "M855.389,412.62l14.021,7.812V403.967l-14.021-7.812Z",
    transform: "translate(-855.389 -396.155)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181942",
    "data-name": "\\uADF8\\uB8F9 181942"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130531",
    "data-name": "\\uD328\\uC2A4 130531",
    d: "M869.048,420.307a.237.237,0,0,1-.116-.03l-14.021-7.812a.238.238,0,0,1-.123-.208V395.793a.239.239,0,0,1,.355-.209l14.021,7.812a.238.238,0,0,1,.122.209v16.464a.237.237,0,0,1-.118.205A.242.242,0,0,1,869.048,420.307Zm-13.783-8.19,13.545,7.546V403.745L855.265,396.2Z",
    transform: "translate(-854.788 -395.555)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181946",
    "data-name": "\\uADF8\\uB8F9 181946"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181944",
    "data-name": "\\uADF8\\uB8F9 181944",
    transform: "translate(0.239 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130532",
    "data-name": "\\uD328\\uC2A4 130532",
    d: "M855.389,385.318l14.1,7.826,12.8-7.174-14.1-7.826Z",
    transform: "translate(-855.389 -378.144)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181945",
    "data-name": "\\uADF8\\uB8F9 181945"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130533",
    "data-name": "\\uD328\\uC2A4 130533",
    d: "M869.13,393.021a.242.242,0,0,1-.116-.03l-14.1-7.826a.24.24,0,0,1-.123-.208.237.237,0,0,1,.122-.208l12.8-7.174a.239.239,0,0,1,.232,0l14.1,7.826a.238.238,0,0,1,0,.417l-12.8,7.173A.24.24,0,0,1,869.13,393.021Zm-13.614-8.065,13.614,7.554,12.311-6.9-13.614-7.554Z",
    transform: "translate(-854.788 -377.545)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181949",
    "data-name": "\\uADF8\\uB8F9 181949",
    transform: "translate(14.282 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181947",
    "data-name": "\\uADF8\\uB8F9 181947",
    transform: "translate(0.239 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130534",
    "data-name": "\\uD328\\uC2A4 130534",
    d: "M903.962,414.832l-12.621,6.734v-16.63l12.621-7.091Z",
    transform: "translate(-891.341 -397.844)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181948",
    "data-name": "\\uADF8\\uB8F9 181948"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130535",
    "data-name": "\\uD328\\uC2A4 130535",
    d: "M890.979,421.442a.237.237,0,0,1-.239-.238V404.574a.239.239,0,0,1,.121-.208l12.621-7.091a.239.239,0,0,1,.355.208v16.988a.24.24,0,0,1-.126.21l-12.621,6.734A.238.238,0,0,1,890.979,421.442Zm.238-16.729v16.094l12.145-6.481V397.89Zm12.383,9.757h0Z",
    transform: "translate(-890.74 -397.244)",
    fill: "#111"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181960",
    "data-name": "\\uADF8\\uB8F9 181960",
    transform: "translate(43.37 43.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181953",
    "data-name": "\\uADF8\\uB8F9 181953",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181951",
    "data-name": "\\uADF8\\uB8F9 181951",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130536",
    "data-name": "\\uD328\\uC2A4 130536",
    d: "M910.609,414.446l14.021,7.812V405.793l-14.021-7.812Z",
    transform: "translate(-910.609 -397.982)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181952",
    "data-name": "\\uADF8\\uB8F9 181952"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130537",
    "data-name": "\\uD328\\uC2A4 130537",
    d: "M924.269,422.135a.235.235,0,0,1-.116-.031l-14.021-7.812a.237.237,0,0,1-.122-.207V397.62a.238.238,0,0,1,.117-.206.241.241,0,0,1,.236,0l14.021,7.812a.239.239,0,0,1,.123.209V421.9a.239.239,0,0,1-.238.238Zm-13.782-8.191,13.544,7.546V405.571l-13.544-7.546Z",
    transform: "translate(-910.01 -397.382)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181956",
    "data-name": "\\uADF8\\uB8F9 181956"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181954",
    "data-name": "\\uADF8\\uB8F9 181954",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130538",
    "data-name": "\\uD328\\uC2A4 130538",
    d: "M910.609,387.145l14.1,7.826,12.8-7.174-14.1-7.826Z",
    transform: "translate(-910.609 -379.972)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181955",
    "data-name": "\\uADF8\\uB8F9 181955"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130539",
    "data-name": "\\uD328\\uC2A4 130539",
    d: "M924.351,394.848a.236.236,0,0,1-.116-.03l-14.1-7.826a.239.239,0,0,1,0-.416l12.8-7.173a.241.241,0,0,1,.232,0l14.1,7.826a.239.239,0,0,1,.122.208.236.236,0,0,1-.121.209l-12.8,7.174A.234.234,0,0,1,924.351,394.848Zm-13.614-8.066,13.614,7.554,12.312-6.9-13.614-7.554Z",
    transform: "translate(-910.01 -379.372)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181959",
    "data-name": "\\uADF8\\uB8F9 181959",
    transform: "translate(14.282 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181957",
    "data-name": "\\uADF8\\uB8F9 181957",
    transform: "translate(0.239 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130540",
    "data-name": "\\uD328\\uC2A4 130540",
    d: "M959.182,416.658l-12.621,6.735V406.762l12.621-7.091Z",
    transform: "translate(-946.56 -399.671)",
    fill: "#8b75f3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181958",
    "data-name": "\\uADF8\\uB8F9 181958"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130541",
    "data-name": "\\uD328\\uC2A4 130541",
    d: "M946.2,423.269a.239.239,0,0,1-.239-.238V406.4a.238.238,0,0,1,.122-.208L958.7,399.1a.238.238,0,0,1,.355.208V416.3a.237.237,0,0,1-.126.211l-12.621,6.734A.242.242,0,0,1,946.2,423.269Zm.238-16.729v16.094l12.145-6.48V399.716ZM958.82,416.3h0Z",
    transform: "translate(-945.96 -399.071)",
    fill: "#111"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181970",
    "data-name": "\\uADF8\\uB8F9 181970",
    transform: "translate(39.711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181963",
    "data-name": "\\uADF8\\uB8F9 181963",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181961",
    "data-name": "\\uADF8\\uB8F9 181961",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130542",
    "data-name": "\\uD328\\uC2A4 130542",
    d: "M901.4,305.433l14.021,7.812V296.78L901.4,288.968Z",
    transform: "translate(-901.398 -288.968)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181962",
    "data-name": "\\uADF8\\uB8F9 181962"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130543",
    "data-name": "\\uD328\\uC2A4 130543",
    d: "M915.058,313.121a.243.243,0,0,1-.116-.03l-14.021-7.812a.238.238,0,0,1-.122-.208V288.606a.238.238,0,0,1,.354-.209l14.021,7.812a.237.237,0,0,1,.123.208v16.465a.239.239,0,0,1-.238.238Zm-13.783-8.19,13.544,7.546V296.558l-13.544-7.546Z",
    transform: "translate(-900.799 -288.368)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181966",
    "data-name": "\\uADF8\\uB8F9 181966"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181964",
    "data-name": "\\uADF8\\uB8F9 181964",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130544",
    "data-name": "\\uD328\\uC2A4 130544",
    d: "M901.4,278.131l14.1,7.826,12.8-7.174-14.1-7.826Z",
    transform: "translate(-901.398 -270.958)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181965",
    "data-name": "\\uADF8\\uB8F9 181965"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130545",
    "data-name": "\\uD328\\uC2A4 130545",
    d: "M915.14,285.834a.242.242,0,0,1-.116-.03l-14.1-7.826a.238.238,0,0,1,0-.416l12.8-7.174a.24.24,0,0,1,.233,0l14.1,7.826a.241.241,0,0,1,.123.208.238.238,0,0,1-.122.208l-12.8,7.173A.233.233,0,0,1,915.14,285.834Zm-13.614-8.065,13.614,7.554,12.311-6.9-13.614-7.554Z",
    transform: "translate(-900.799 -270.358)",
    fill: "#111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181969",
    "data-name": "\\uADF8\\uB8F9 181969",
    transform: "translate(14.282 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181967",
    "data-name": "\\uADF8\\uB8F9 181967",
    transform: "translate(0.239 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130546",
    "data-name": "\\uD328\\uC2A4 130546",
    d: "M949.971,307.645l-12.622,6.734v-16.63l12.622-7.091Z",
    transform: "translate(-937.35 -290.658)",
    fill: "#8b75f3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_181968",
    "data-name": "\\uADF8\\uB8F9 181968"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130547",
    "data-name": "\\uD328\\uC2A4 130547",
    d: "M936.988,314.256a.239.239,0,0,1-.239-.238v-16.63a.238.238,0,0,1,.122-.208l12.621-7.091a.239.239,0,0,1,.356.208v16.987a.237.237,0,0,1-.127.21l-12.62,6.734A.237.237,0,0,1,936.988,314.256Zm.238-16.729V313.62l12.145-6.48V290.7Zm12.383,9.757h0Z",
    transform: "translate(-936.749 -290.058)",
    fill: "#111"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCube3);
export default __webpack_public_path__ + "static/media/information_cube3.69e0bf0d142e2e3719b2f60d0ad59e35.svg";
export { ForwardRef as ReactComponent };